import { getRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const ATTENDEESNETWORK_TOTAL_MSGSENT = "ATTENDEESNETWORK_TOTAL_MSGSENT";

const attendeesnetworkmsgsentcount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=atndnetwmsgsentcnt&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;
        //Prepare data for Device Installs..
        //dispatch({type: ATTENDEESNETWORK_TOTAL_MSGSENT,payload:data.resource.length});
        dispatch({
          type: ATTENDEESNETWORK_TOTAL_MSGSENT,
          payload: { count: data.count },
        });
        callback({
          error: 0,
          data: "Analytics Attendees Message Sent Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { attendeesnetworkmsgsentcount };
